import DataStore from "../../../stores/DataStore";
import { E_TIPO_TELA } from "./Enum";
import ServicosService from "../services/ServicosService";

export default class SimulacaoServicosAcessStore extends DataStore {

    servicosAcessorios = this.defaultObj([]);

    constructor() {
        super();
    };

    populateServicosAcessorios = async (requestBody, servicosJaIncluidos = []) => {
        this.setLoading(this.servicosAcessorios);

        try {
            const { status, data } = await ServicosService.buscarServicos(requestBody);

            if (status == 200) {
                const agrupadoresAdicionados = [...new Set(servicosJaIncluidos.map(({ AgrupadorServico }) => AgrupadorServico))].filter(a => a > 0);
                
                const servicosAcessorios = this.filtraServicosAcessoriosRepetidos(data)
                    .filter(serv => !servicosJaIncluidos.find(({ Codigo }) => Codigo == serv.Codigo))
                    .filter(serv => !agrupadoresAdicionados.find(agr => agr == serv.AgrupadorServico))
                ;

                this.setValue(this.servicosAcessorios, servicosAcessorios);
            }
            else {
                this.setError(this.servicosAcessorios, data.Message || "Ocorreu um erro!");
            }
        } catch (error) {
            console.log(error)
            this.setError(this.servicosAcessorios, "Ocorreu um erro na busca.");       
        } finally {
            this.setLoading(this.servicosAcessorios, false);
        }
    }

    getServicosByItem = async (servicosSelecionados, requestBody, tipoTela) => {
        try {
            const { status, data } = await ServicosService.buscarServicos(requestBody);

            if (status == 200) {
                return servicosSelecionados.filter(({ Codigo }) => data.find(c => c.Codigo == Codigo));
            }
            else {
                return [];
            }
        } catch (error) {
            console.log(error)
        }
    }

    selecionaServicoAcessorio = (isSelect, codigo) => {
        if (!codigo) throw new Error("Código inválido");
        
        const servicosSelecionados = this.servicosAcessorios.value.map(serv => 
            (serv.Codigo == codigo ? {...serv, Selecionado: isSelect} : serv));

        this.setValue(this.servicosAcessorios, servicosSelecionados);
    }

    buscarServicosVinculados = async (servicosIds) => {
        this.setLoading(this.servicosAcessorios);

        try {
            const { status, data } = await ServicosService.buscarServicosVinculados(servicosIds);


            if (status == 200) {
                return data;
            }
            else {
                this.setError(this.servicosAcessorios, data.Message || "Ocorreu um erro!");
            }
        } catch (error) {
            console.log(error)
            this.setError(this.servicosAcessorios, "Ocorreu um erro na busca.");       
        } finally {
            this.setLoading(this.servicosAcessorios, false);
        }
    }

    changeQtd = (ClassificacaoId, newValue) => {
        if (!ClassificacaoId) throw new Error("Código inválido");
        
        const servicosSelecionados = this.servicosAcessorios.value.map(serv => 
            (serv.ClassificacaoId == ClassificacaoId ? {...serv, Qtd: newValue, Selecionado: newValue > 0 } : serv));

        this.setValue(this.servicosAcessorios, servicosSelecionados);
    }

    get ServicosSelecionados() {
        return this.servicosAcessorios.value.filter(({ Selecionado }) => Selecionado);
    }

    get AgrupadoresSelecionados() {
        return this.ServicosSelecionados.map(({ AgrupadorServico }) => AgrupadorServico).filter(a => a);
    }

    get ServicosSelecionadosIds() {
        return this.ServicosSelecionados.map(({ ClassificacaoId }) => ClassificacaoId);
    }

    get NonSelectableIds() {
        return this.servicosAcessorios.value
            .filter(({ Selecionado, AgrupadorServico }) => !Selecionado && this.AgrupadoresSelecionados.includes(AgrupadorServico))
            .map(({ ClassificacaoId }) => ClassificacaoId)
        ;
    }

    resetarServicos = () => {
        this.setValue(this.servicosAcessorios, []);
    }

    filtraServicosAcessoriosRepetidos = (servicosAcessorios) => {
        return servicosAcessorios
            .map(s => ({ ...s, Cntr: null, NumBl: null, Qtd: null }))
            .filter(({ Codigo }, i, ar) => ar.findIndex(item => item.Codigo == Codigo) === i);
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosAcessStore.js